import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexValidation',
  setup(__props) {

const ToltipValidation = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/validation/ToltipValidation.vue"))
const BrowserDefaults = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/validation/BrowserDefaults.vue"))
const ValidationForm = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/validation/ValidationForm.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ToltipValidation)),
      _createVNode(_unref(BrowserDefaults)),
      _createVNode(_unref(ValidationForm))
    ])
  ]))
}
}

})